module.exports = __webpack_public_path__ + "static/media/flag-usa.40317415.svg";